import { refuseInsecurePage } from '../../shared/https-only.js'
import {
  accountOriginFromAppLocation,
  apiFromAppLocation,
  promoteHashRoute
} from '../../shared/app-host.js'

if (refuseInsecurePage(window.document, window.location)) {

  throw new Error('HTTPS is required')
}

if (window.location.hash.startsWith('#/')) {

  window.history.replaceState(null, '', promoteHashRoute(window.location.href))
}

const fromHost = accountOriginFromAppLocation(window.location)
const params = new URLSearchParams(window.location.search)
const fromQuery = params.get('api')

if (!fromHost && fromQuery) {

  window.sessionStorage.setItem('superturboApi', fromQuery)
}

const api = apiFromAppLocation(
  window.location,
  fromHost ? '' : window.sessionStorage.getItem('superturboApi')
)

window.__SUPERTURBO_API__ = api
window.__SUPERTURBO_WS__ = api.replace(/^http/, 'ws')

if (fromHost && params.has('api')) {

  params.delete('api')
  const qs = params.toString()

  window.history.replaceState(null, '', `${window.location.pathname}${qs ? `?${qs}` : ''}`)
}
